import { render, staticRenderFns } from "./decimalComSinalCustom.vue?vue&type=template&id=3a74b4c8"
import script from "./decimalComSinalCustom.ts?vue&type=script&lang=js&external"
export * from "./decimalComSinalCustom.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a74b4c8')) {
      api.createRecord('3a74b4c8', component.options)
    } else {
      api.reload('3a74b4c8', component.options)
    }
    module.hot.accept("./decimalComSinalCustom.vue?vue&type=template&id=3a74b4c8", function () {
      api.rerender('3a74b4c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/form/decimalComSinalCustom.vue"
export default component.exports